import { frontendURL } from '../../../helper/URLHelper';
import ShortenerIndex from './pages/ShortenerIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'url_shortener_manage'],
  dotchatModule: 'url_shortener',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/shortener'),
    component: ShortenerIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'shortener_index',
        component: ShortenerIndex,
        meta: commonMeta,
      },
    ],
  },
];
